import { TrackingStatus } from 'src/types';
import {
  IKameleoonData,
  KameleoonData,
  PersonalizationDataType,
} from './types';
import { VisitType } from 'src/requester';

export class Personalization implements IKameleoonData {
  public status: TrackingStatus;

  private readonly id: number;
  private readonly variationId: number;

  /**
   * @param {number} id
   * @param {number} variationId
   * */
  constructor(id: number, variationId: number) {
    this.id = id;
    this.variationId = variationId;
    this.status = TrackingStatus.Sent;
  }

  get url(): string {
    return '';
  }

  get data(): PersonalizationDataType {
    return {
      id: this.id,
      variationId: this.variationId,
      type: KameleoonData.Personalization,
      status: TrackingStatus.Sent,
    };
  }

  /**
   * @private
   * @method _fromRaw - an internal method for creating a Personalization instance from raw data
   * @param {PersonalizationDataType} data - a raw data
   * @return {Personalization} a Personalization instance
   * */
  public static _fromRaw(data: PersonalizationDataType): Personalization {
    return new Personalization(data.id, data.variationId);
  }

  /**
   * @private
   * @method _updateFromVisit - an internal method for updating a list of Personalization instances
   * @param {VisitType} visit - a visits
   * @param {Map<number, Personalization>} dataMap - a map of Personalization instances
   * */
  public static _updateFromVisit(
    visit: VisitType,
    dataMap: Map<number, Personalization>,
  ): void {
    if (visit.personalizationEvents?.length) {
      for (const personalizationEvent of visit.personalizationEvents) {
        const { id, variationId } = personalizationEvent.data;

        if (!dataMap.has(id)) {
          const personalization = new Personalization(id, variationId);

          dataMap.set(id, personalization);
        }
      }
    }
  }
}
